const docLang = document.documentElement.lang;
export const lang = docLang.length > 2 ? docLang.substring(0, 2) : docLang;
export const labels = {
  prev: {
    de: 'Zum vorherigen Bild springen',
    en: 'move to previous image',
  },
  next: {
    de: 'Zum nächsten Bild springen',
    en: 'move to next image',
  },
  close: {
    de: 'Lightbox Schließen (Esc)',
    en: 'Close lightbox (Esc)',
  },
  zoom: {
    de: 'Bild vergrößern/verkleinern',
    en: 'Zoom image in/out',
  },
  download: {
    de: 'Bild herunterladen',
    en: 'Download Image',
  },
};

const template = `
<div class="pswp" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="pswp__bg"></div>
  <div class="pswp__scroll-wrap">
    <div class="pswp__container">
      <div class="pswp__item"></div>
      <div class="pswp__item"></div>
      <div class="pswp__item"></div>
    </div>
    <div class="pswp__ui pswp__ui--hidden">
      <div class="pswp__top-bar">
        <button class="pswp__button pswp__button--close" title="${
          labels.close[lang]
        }">
          <i class="icon-close" aria-hidden="true"></i>
          <span class="sr-only">${labels[`close_${lang}`]}</span>
        </button>
        <button class="pswp__button pswp__button--zoom" title="${
          labels.zoom[lang]
        }">
        </button>
        <div class="pswp__preloader">
          <div class="pswp__preloader__icn">
            <div class="pswp__preloader__cut">
              <div class="pswp__preloader__donut"></div>
            </div>
          </div>
        </div>
      </div>
      <button class="pswp__button pswp__button--arrow--left" title="${
        labels.prev[lang]
      }">
        <span class="sr-only">${labels[`prev_${lang}`]}</span>
        <i class="icon-arrow-left" aria-hidden="true"></i>
      </button>
      <button class="pswp__button pswp__button--arrow--right" title="${
        labels.next[lang]
      }">
        <span class="sr-only">${labels[`next_${lang}`]}</span>
        <i class="icon-arrow-right" aria-hidden="true"></i>
      </button>
      <div class="pswp-container">
        <div class="pswp_imagetitle_text copy">
          <p id="pswp_imagetitle"></p>
        </div>
      </div>
      <div class="pswp__caption">
        <div class="pswp__caption__center">
        </div>
      </div>
      <div class="pswp__counter"></div>
    </div>
  </div>
</div>
`;

export default template;
